/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, July 2021
 * @format
 * @flow
 */

import React from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';
import UTILLib from '../../../../util';
import API from "../../../../requests";
import backImg from '../../../../assets/images/Fireboard/back2_red.png';
import crossImg from '../../../../assets/images/Fireboard/crossRed.png';
import checkImg from '../../../../assets/images/Fireboard/paid.png';
import Button from "../../../../components/Button";
import Checkbox from '../../../../components/Checkbox';
import strings from '../../../../globalization';
import CommonUtils from "../../common";
import classes from "./BatchPreauth.module.css";

class BatchPreauth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      preauthChecks: new Map(),
      allSelected: false,
      isSubmitted: false,
      enableCancel: false,
      preAuthCompleted: false,
    };
    this.isCancelled = false;
  }

  componentDidMount() {
    const { checks, defaultPreAuthTipPercentage, supportsGratuityForPreAuth } = this.props;
    let preauthChecks = new Map();
    const isGratuityEnabled = supportsGratuityForPreAuth || defaultPreAuthTipPercentage > 0;
    checks && checks.forEach(check => {
      const gratuityPercentage = defaultPreAuthTipPercentage * 100;
      const gratuityAmount = this.calculateGratuity(check, +gratuityPercentage);
      preauthChecks.set(check.id, {
        ...check,
        gratuityPercentage: gratuityPercentage,
        gratuityAmount: gratuityAmount,
        defaultGratuityAmount: gratuityAmount,
        isGratuityEnabled,
        preauthStatusIcon: '',
        preauthErrorMsg: '',
        isSelected: false,
      });
    });
    this.setState({ preauthChecks });
  }

  calculateGratuity = (check, newGratuity) => {
    const { reduxProps: { storeInfo } } = this.props;
    const { tipInfo } = storeInfo?.data || {};
    const { suggestedTipIncludesTax } = tipInfo || {};

    const { unpaidAmount, taxAmount, subTotalAmount } = check?.selectedCheckDetails || {};
    let gratuityAmount = 0;
    if (suggestedTipIncludesTax) {
      gratuityAmount = (unpaidAmount * newGratuity) / 100;
    } else {
      const taxPercent = taxAmount / subTotalAmount;
      const subTotalForUnpaidAmt = unpaidAmount / (1 + taxPercent);
      gratuityAmount = (subTotalForUnpaidAmt * newGratuity) / 100;
    }
    return gratuityAmount;
  };

  onChangeTip = (value, checkId) => {
    const { defaultPreAuthTipPercentage } = this.props;
    let copiedPreauthChecks = new Map(this.state.preauthChecks);
    const gratuity = +value;
    const check = copiedPreauthChecks.get(checkId);
    let gratuityAmount = check.defaultGratuityAmount;
    if (/^\d+(\.\d{1,2})?$/.test(gratuity) && gratuity <= defaultPreAuthTipPercentage * 100) {
      gratuityAmount = this.calculateGratuity(copiedPreauthChecks.get(checkId), gratuity);
    }
    copiedPreauthChecks.set(checkId, {
      ...check,
      gratuityPercentage: value,
      gratuityAmount: gratuityAmount,
    })
    this.setState({ preauthChecks: copiedPreauthChecks });
  };


  getPayload = check => {
    const { defaultPreAuthTipPercentage, reduxProps } = this.props;
    const { storeInfo, deviceApi, login } = reduxProps;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    const { id: employeeId } = login?.data || {};

    const { latitude, longitude } = UTILLib.location;
    const { gratuityPercentage, tickets, unpaidAmount, id } = check;
    const allowedValue = defaultPreAuthTipPercentage * 100;
    let gratuity = gratuityPercentage;
    if (gratuity > allowedValue) {
      gratuity = allowedValue;
    }
    const preauthTicket =
      Array.isArray(tickets) &&
      tickets.find(ticket => ticket.ticketStatusId === 0 && ticket.preAuth && unpaidAmount > 0);
    const finalGratuity = this.calculateGratuity(check, +gratuity);
    return {
      latitude,
      longitude,
      geoLocation: `${latitude} ${longitude}`,
      storeId: storeId,
      deviceId: deviceId,
      employeeId: employeeId,
      checkHeaderId: id,
      ticketId: preauthTicket ? preauthTicket?.id : null,
      totalAmount: +unpaidAmount,
      tipAmount: +(finalGratuity.toFixed(2)),
      paymentAmount: +((unpaidAmount + finalGratuity).toFixed(2)),
      bulk: true,
    }
  };

  onCancel = () => {
    if (this.state.enableCancel) {
      this.isCancelled = true;
      this.setState({ enableCancel: false });
    }
  };

  onSubmit = () => {
    const { preauthChecks } = this.state;
    const preauthChecksArray = Array.from(preauthChecks.values());
    const selectedChecks = preauthChecksArray.filter(check => check.isSelected);
    if (selectedChecks.length > 0) {
      this.setState({ isSubmitted: true, enableCancel: true });
      this.onSubmitPreauth(selectedChecks);
    }
  };

  onSubmitPreauth = async (selectedChecks) => {
    for (var index = 0, len = selectedChecks.length; index < len; index++) {
      const { preauthChecks } = this.state;
      const check = selectedChecks[index];
      //set loading true
      preauthChecks.set(check.id, {
        ...check,
        preauthStatus: 'loading',
        preauthErrorMsg: `Processing pre auth for check #${check.number}`,
      });
      this.setState({ preauthChecks, allSelected: false });

      try {
        const response = await API.preAuthCompleteFB(this.getPayload(check));
        const updatedCheck = response.data;
        const preauthCheck = preauthChecks.get(updatedCheck.id);
        preauthChecks.set(updatedCheck.id, {
          ...preauthCheck,
          ...CommonUtils.parseCheckFromRedis(updatedCheck),
          preauthStatus: 'success',
          preauthErrorMsg: '',
          isSelected: false,
        });
        this.setState({ preauthChecks });
      } catch (error) {
        const errorMsg = error.response ? error.response?.data?.message : error.message;
        preauthChecks.set(check.id, {
          ...check,
          preauthStatus: 'error',
          preauthErrorMsg: errorMsg,
          isSelected: false,
        });
        this.setState({ preauthChecks });
      }

      //if cancel is clicked
      if (this.isCancelled) break;
    }

    this.setState({ preAuthCompleted: true });
  };

  onToggleCheckbox = id => {
    const { preauthChecks } = this.state;
    const copiedPreauthChecks = new Map(preauthChecks);
    if (copiedPreauthChecks.has(id)) {
      const check = copiedPreauthChecks.get(id);
      copiedPreauthChecks.set(id, { ...check, isSelected: !check?.isSelected });
      this.setState({ preauthChecks: copiedPreauthChecks }, () =>
        this.areAllSelected()
      );
    }
  };

  onSelectAll = () => {
    const { preauthChecks, allSelected } = this.state;
    const copiedPreauthChecks = new Map(preauthChecks);
    if (allSelected) {  //deselect all checks
      copiedPreauthChecks.forEach(check => copiedPreauthChecks.set(check.id, { ...check, isSelected: false }));
    } else { //select all checks
      copiedPreauthChecks.forEach(check => copiedPreauthChecks.set(check.id, { ...check, isSelected: true }));
    }
    this.setState(prevState => {
      return {
        preauthChecks: copiedPreauthChecks,
        allSelected: !prevState.allSelected,
      };
    });
  };

  areAllSelected = () => {
    const { preauthChecks } = this.state;
    const list = Array.from(preauthChecks.values());
    const notAllSelected = list.some(el => !el.isSelected);
    this.setState({ allSelected: !notAllSelected });
  };

  getStatus = statusText => {
    let statusJSX = null;
    if (statusText) {
      if (statusText === 'loading')
        statusJSX = <Spineer />;
      else if (statusText === 'success')
        statusJSX = <img src={checkImg} className={classes.statusIcon} alt='success' />;
      else if (statusText === 'error')
        statusJSX = <img src={crossImg} className={classes.statusIcon} alt='error' />;
    }
    return statusJSX;
  };

  renderContent = (check) => {
    const {
      id,
      number,
      stationName,
      employeeFirstName,
      employeeLastName,
      unpaidAmount,
      isGratuityEnabled,
      gratuityPercentage,
      gratuityAmount,
      defaultGratuityAmount,
      preauthStatus,
      preauthErrorMsg,
      isSelected,
    } = check;
    const { currency, defaultPreAuthTipPercentage } = this.props;
    return (
      <div className={classes.rowWrapper} key={`check id - ${id}`}>
        <div className={[classes.contentTxt, classes.selectCol].join(' ')}>
          <Checkbox checked={isSelected} onChange={() => this.onToggleCheckbox(id)} />
        </div>
        <div className={[classes.contentTxt, classes.checkNumCol].join(' ')}>{number}</div>
        <div className={[classes.contentTxt, classes.tableNumCol].join(' ')}>{stationName}</div>
        <div className={[classes.contentTxt, classes.empCol].join(' ')}>{employeeFirstName} {employeeLastName}</div>
        <div className={[classes.contentTxt, classes.totalCol].join(' ')}>{currency}{unpaidAmount}</div>
        <div className={[classes.tipWrapper, classes.tipCol].join(' ')}>
          <input
            type='number'
            disabled={!isGratuityEnabled}
            value={gratuityPercentage}
            onChange={e => this.onChangeTip(e.target.value, id)}
            className={[+gratuityPercentage > (defaultPreAuthTipPercentage * 100) ? classes.invalidInput : classes.validInput]}
          />
          <span className={classes.percentTxt} style={{ marginRight: 10 }}>%</span>
          <span className={classes.percentTxt}>({`${currency} ${gratuityAmount.toFixed(2) || defaultGratuityAmount.toFixed(2)}`})</span>
        </div>
        <div className={[classes.contentTxt, classes.paymentCol].join(' ')}>
          {`${currency} ${(unpaidAmount + gratuityAmount).toFixed(2)}`}
        </div>
        <div className={[classes.tipWrapper, classes.statusCol].join(' ')}>
          {this.getStatus(preauthStatus)}
        </div>
        <div className={[classes.contentTxt, classes.msgCol].join(' ')}>
          <span className={classes.errorMsg}>{preauthErrorMsg}</span>
        </div>
      </div>
    );
  };

  render() {
    const { preauthChecks, allSelected, isSubmitted, enableCancel, preAuthCompleted } = this.state;
    const checkArray = Array.from(preauthChecks.values());
    const { dismissPopup } = this.props;
    return (
      <div className={classes.container}>
        <div className={classes.headerWrapper}>
          <Button disabled={(isSubmitted && !preAuthCompleted)} className={classes.backButton} onClick={dismissPopup}>
            <img src={backImg} className={classes.backImage} alt="Back" />
          </Button>
          <span className={classes.title}>{strings.bulkPreAuth}</span>
          <Button disabled={isSubmitted} className={classes.button} onClick={this.onSubmit}>
            <span className={classes.buttonText}>{strings.submit}</span>
          </Button>
          <Button disabled={(!enableCancel || preAuthCompleted)} className={classes.button} onClick={this.onCancel}>
            <span className={classes.buttonText}>{strings.cancel}</span>
          </Button>
        </div>
        <Header checked={allSelected} onChange={this.onSelectAll} />
        <div className={classes.bodyWrapper}>
          {checkArray.map(check => this.renderContent(check))}
        </div>
      </div>
    );
  }
};

const mapStateToProps = (reduxProps) => ({
  reduxProps,
});

export default connect(mapStateToProps, null)(BatchPreauth);

const Header = ({ checked, onChange }) => (
  <div className={classes.rowWrapper}>
    <div className={[classes.headerTitle, classes.selectCol].join(' ')}>
      <Checkbox checked={checked} onChange={onChange} />
    </div>
    <div className={[classes.headerTitle, classes.checkNumCol].join(' ')}>Check#</div>
    <div className={[classes.headerTitle, classes.tableNumCol].join(' ')}>Table#</div>
    <div className={[classes.headerTitle, classes.empCol].join(' ')}>Employee</div>
    <div className={[classes.headerTitle, classes.totalCol].join(' ')}>Total</div>
    <div className={[classes.headerTitle, classes.tipCol].join(' ')}>Tip</div>
    <div className={[classes.headerTitle, classes.paymentCol].join(' ')}>Payment</div>
    <div className={[classes.headerTitle, classes.statusCol].join(' ')}>Status</div>
    <div className={[classes.headerTitle, classes.msgCol].join(' ')}>Message</div>
  </div>
);

const Spineer = () => (
  <Loader
    type="Oval"
    color={'white'}
    height="30"
    width="30"
    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
  />
);
